
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { UserDropdown } from '@mg/micro/vue2/UserDropdown'
import { DesktopIconsItem as HeaderDesktopIconsItem } from '@mg/micro/vue2'
import IconUserOutline from '@mg/web-components/Atoms/Icon/IconUserOutline.vue'
import IconVip from '@mg/web-components/Atoms/Icon/IconVip'
import IconSmartFreeDelivery from '@mg/web-components/Atoms/Icon/IconSmartFreeDelivery.vue'
import { GQLMenu, GQLUser } from '~/graphql/__generated__/interfaces'
import AppLink from '~/components/AppLink.vue'
import {
  GQLLocalAccount,
  GQLLocalOpenHeaderEnum,
} from '~/graphql/__generated__/interfacesLocal'
import { GET_BASIC_USER_INFO } from '~/graphql/gql/user'
import ROUTES from '~/config/routes'
import getVipIcon from '~/utils/getVipIcon'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import { getMenuGQL, MENU_TYPE } from '@mg/micro/data/gql/menu'
import { getMenuVariables } from '~/utils/getMenuVariables'
import ApolloFetchPolicies from '~/utils/apolloFetchPolicies'

@Component<HeaderUserSigned>({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    getUserMenu: {
      fetchPolicy: ApolloFetchPolicies.CACHE_ONLY,
      query: getMenuGQL,
      update(data: { getMenu: GQLMenu }) {
        return data.getMenu
      },
      variables() {
        return getMenuVariables(
          MENU_TYPE.KC,
          this.$route.query.naviPreview as string,
          this.$shopConfig.abTests.abTestsData.menuAbTest,
          false
        )
      },
    },
    user: {
      query: GET_BASIC_USER_INFO,
      skip() {
        return !this.$shopConfig.user?.id && !this.account?.isLogged
      },
    },
  },
  components: {
    AppLink,
    HeaderDesktopIconsItem,
    IconUserOutline,
    IconVip,
    IconSmartFreeDelivery,
    UserDropdown,
  },
  filters: {
    name: ({ lastName, firstName }: GQLUser) => `${firstName} ${lastName}`,
    shortName: ({ lastName, firstName }: GQLUser) =>
      `${firstName} ${lastName?.slice(0, 1) ?? ''}.`,
  },
})
export default class HeaderUserSigned extends Vue {
  @Prop({ default: 'right', type: String }) dropDownPosition: 'left' | 'right'
  @Prop({ default: false, type: Boolean }) disableUserLink!: boolean

  user: GQLUser
  account: GQLLocalAccount
  getUserMenu: GQLMenu
  @Prop(Boolean) isOpenState: boolean
  getVipIcon = getVipIcon
  routes = ROUTES

  openToggle() {
    this.isOpenState ? this.closed() : this.open()
  }

  open() {
    this.changeTab(GQLLocalOpenHeaderEnum.User)
  }

  slowClosed() {
    this.changeTab(null)
  }

  closed() {
    this.closeTab()
  }

  @Emit('changeTab')
  changeTab(tabName: null | GQLLocalOpenHeaderEnum) {
    return tabName
  }

  @Emit()
  closeTab() {}

  async logout(event: Event) {
    event.preventDefault()
    await this.$webApi.logout()
    window.location.replace('/')
  }

  get translations() {
    return {
      hdg_widget_is_vip: this.$t('common.hdg_widget_is_vip'),
      logout: this.$t('common.logout'),
    }
  }

  get shouldShowSmartIcon() {
    const smartClubId = this.$shopConfig.webConfig.mallSmartClubId
    return this.user?.clubs?.find((club) => {
      return club.id === smartClubId && club.status === 'A'
    })
  }
}
